import React from "react";

const AddressDetailsSection = ({
  applicant,
  showAddressDetails,
  setShowAddressDetails,
  handleAddressEditClick,
}) => {
  return (
    <div className="mb-4">
      <div
        className="d-flex align-items-center mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => setShowAddressDetails(!showAddressDetails)}
      >
        <span
          style={{
            color: "#e91e63",
            fontSize: "14px",
            fontWeight: "600",
            marginRight: "8px",
          }}
        >
          Addresses
        </span>
        <i
          className={`fas fa-chevron-${showAddressDetails ? "down" : "right"}`}
          style={{ color: "#e91e63", fontSize: "12px" }}
        ></i>
      </div>

      {showAddressDetails && (
        <div className="[ details-section ] [ mb-3 ]">
          <div className="[ row ] [ details-section__header">
            <div className="[ col-12 ]">
              <h3 className="[ d-flex justify-content-between align-items-center ]">
                ADDRESS DETAILS
                <button
                  type="button"
                  className="[ btn edit-btn ]"
                  aria-label="edit"
                  onClick={handleAddressEditClick}
                >
                  <span className="[ edit-icon ]"></span>
                  <span className="[ edit-btn__label ]">Edit</span>
                </button>
              </h3>
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-12 ] [ details-section__item-label ]">
              Residential address:
            </div>
            <div className="[ col-12 ] [ address-details-section__item-description ]">
              {applicant?.address?.currentAddressLine1 || "—"}
              <br />
              {applicant?.address?.currentAddressUnitNumber
                ? `Unit # ${applicant?.address?.currentAddressUnitNumber}, `
                : ""}
              {applicant?.address?.currentAddressCity
                ? `${applicant?.address?.currentAddressCity},`
                : ""}{" "}
              {applicant?.address?.currentAddressProvince || ""}
              <br />
              {applicant?.address?.currentAddressPostalCode || ""}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-12 ] [ details-section__item-label ]">
              Mailing address:
            </div>
            <div className="[ col-12 ] [ address-details-section__item-description ]">
              {/* Mailing Address */}
              {(applicant?.address?.mailingSameAsCivic ||
                !applicant?.address?.mailingAddressLine1) && (
                <div>
                  {applicant?.address?.currentAddressLine1 || "—"}
                  <br />
                  {applicant?.address?.currentAddressUnitNumber
                    ? `Unit # ${applicant?.address?.currentAddressUnitNumber}, `
                    : ""}
                  {applicant?.address?.currentAddressCity
                    ? `${applicant?.address?.currentAddressCity},`
                    : ""}{" "}
                  {applicant?.address?.currentAddressProvince || ""}
                  <br />
                  {applicant?.address?.currentAddressPostalCode || ""}
                </div>
              )}
              {!applicant?.address?.mailingSameAsCivic &&
                applicant?.address?.mailingAddressLine1 && (
                  <div>
                    {applicant?.address?.mailingAddressLine1 || "—"}
                    <br />
                    {applicant?.address?.mailingUnitNumber
                      ? `Unit # ${applicant?.address?.mailingUnitNumber}, `
                      : ""}
                    {applicant?.address?.mailingCity
                      ? `${applicant?.address?.mailingCity},`
                      : ""}{" "}
                    {applicant?.address?.mailingProvince || ""}
                    <br />
                    {applicant?.address?.mailingPostalCode || ""}
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressDetailsSection;
